import React, { Component } from "react";
import _ from "lodash";
import { TenantContractContext, updateTenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";
import { WebFormFieldProps } from "@eres/forms-web";
import FormSection from "@my-dld/components/Form/FormSection";
import Strings from "@my-dld/assets/strings";
import StateHolder from "@eres/forms/StateHolder";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import FormRow from "@eres/forms-web/FormRow";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "../../utils";
import { defaultErrorManager } from "@eres/forms/errormanager";
import FormAction from "@my-dld/components/Form/FormAction";
import { navigate } from "@my-dld/utils/StoreUtils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import { TCCoOccupantsInfo } from "@eres/ejari-api/Entity/tenant";
import TextInputField from "@eres/forms-web/TextInputField";
import FormMandatory from "../FormMandatory";
import NumberConverter from "@eres/forms/converters/NumberConverter";

interface Props extends RoutedViewProps {

}

interface State extends LoadableDataState {
	newData?: TCCoOccupantsInfo;
	orgData?: TCCoOccupantsInfo;
}

class CoOccupantsInfo extends Component<Props, State> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
		};
	}

	componentDidMount() {
		this.updateFromContext();
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
			valueManager: dualDataManager,
			errorManager: defaultErrorManager,
		};
		const { action } = this.context;
		return <div className="tender-registration-form">
			<FormSection title={ Strings.no_of_co_occupants }>
				<FormMandatory/>
				<FormRow { ...filedProps }>
					<TextInputField
						required={ true }
						id={ "TotalCoTenants" }
						label={ Strings.no_of_co_occupants }
						valueManager={ dualDataManager }
						valueConverter={ NumberConverter }
						maxLength={ 3 }
					/>
				</FormRow>
				<FormRow { ...filedProps }>
					<RenderActions
						action={ action! } onContinue={ this.onContinue }
						onSave={ this.onSave } onBack={ this.onBack }/>
				</FormRow>
			</FormSection>
		</div>;
	}

	private updateFromContext() {
		const { contract, coOccupantsInfo } = this.context;
		const orgCoOccupants: TCCoOccupantsInfo = {};
		if ( contract ) {
			orgCoOccupants.TotalCoTenants = contract.TotalCoTenants;
		}
		const state = {
			orgData: orgCoOccupants || {},
			newData: coOccupantsInfo || {},
		};
		this.setState( { ...this.state, ...state } );
	}

	private getUpdatedData = ( state: State = this.state ) => {
		const data: TCCoOccupantsInfo = {};
		_.merge( data, state.orgData, state.newData );
		return data;
	};

	private isValid() {
		const data = this.getUpdatedData();
		const error: ErrorContainer = {};
		let isValid = checkNonEmpty( data, "TotalCoTenants", error );
		if ( isValid ) {
			isValid = data.TotalCoTenants! <= this.context.AllowedCoTenants!;
			if ( !isValid ) error[ "TotalCoTenants" ] = Strings.allowed_co_tenants.format( this.context.AllowedCoTenants!.toString() );
		}
		this.setState( {
			errorContainer: error,
		} );
		return isValid;
	}

	private onContinue = () => {
		if ( this.isValid() ) {
			const data = this.getUpdatedData();
			const coOccupantsInfo: TCCoOccupantsInfo = {
				...data,
				TotalCoTenants: data.TotalCoTenants,
			};
			updateTenantContractContext( { coOccupantsInfo: coOccupantsInfo } );
			navigate( "contract" );
		}
	};

	private onSave = () => {
		if ( this.isValid() ) {
			let { contract } = this.context;
			const data = this.getUpdatedData();
			contract = {
				...contract,
				TotalCoTenants: data.TotalCoTenants,
			};
			updateTenantContractContext( { contract: contract, coOccupantsInfo: data } );
			this.onBack();
		}
	};

	private onBack = () => {
		const { action } = this.context;
		if ( action === TenancyContactAction.NEW_CONTRACT )
			this.props.history.go( -2 );
		else
			this.props.history.goBack();
	};
}

export function RenderActions( props: {
	action: string, onContinue: () => void, onSave: () => void,
	onBack: () => void, pLabel?: string
} ) {
	const { action, onContinue, onSave, onBack, pLabel } = props;
	return <React.Fragment>
		{ ( action === TenancyContactAction.UPDATE_CONTRACT ) ?
			<FormAction
				groupClassName={ "text-center" }
				primaryActionLabel={ Strings.save }
				onPrimaryAction={ onSave }
				secondaryActionLabel={ Strings.back }
				onSecondaryAction={ onBack }
				actionContainerClassName={ "col-md-12" }/> :
			<FormAction
				groupClassName={ "text-center" }
				primaryActionLabel={ pLabel ? pLabel : Strings.continue }
				onPrimaryAction={ onContinue }
				secondaryActionLabel={ Strings.back }
				onSecondaryAction={ onBack }
				actionContainerClassName={ "col-md-12" }/> }
	</React.Fragment>;
}

export default CoOccupantsInfo;
